<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Ticket Details</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboard' }">Dashboard</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'support-ticket' }">Support Ticket</router-link>
              </li>
              <li class="breadcrumb-item active">Ticket Details</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-8">
            <section class="ticket">
              <div class="ticket-details">
                <div class="ticket-details-head">
                  <h5>
                    Ticket ID: #{{ ticketData.id ? ticketData.id : ""
                    }}<span>{{
                      customFormatterV1(ticketData.created_at)
                    }}</span>
                  </h5>
                  <div class="status" :class="ticketData.statusClass">
                    {{
                      ticketData.ticket_state
                        ? ticketData.ticket_state.states
                        : ""
                    }}
                  </div>
                </div>
                <h3>{{ ticketData.title ? ticketData.title : "" }}</h3>
                <p v-html="ticketData.body"></p>
              </div>
              <!-- <label class="control-label">Ticket Attachments</label> -->
              <div class="attachment-list mt-3">
                <div v-for="(a, i) in ticketData.attachments" class="img-thumbnail" :key="i">
                  <img class="rounded" :src="a" style="max-width: 100%" height="64"
                    @click.prevent="openImageInBrowser" />
                </div>
              </div>

              <div class="ticket-reply">
                <h3>Reply</h3>
                <div v-for="(val, index) in ticketData.ticket_notes" :key="'ticket_note_' + index"
                  class="ticket-reply-box">
                  <div class="ticket-reply-box-head">
                    <div v-if="
                      val.note_type != null &&
                      val.note_type.trim() == 'note-to-customer'
                    ">
                      <img class="img-circle" src="../../../public/assets/images/favicon-16x16.png" alt="" />
                      {{ companyName }}
                    </div>
                    <div v-else>
                      <img class="img-circle" v-bind:src="profile.avatar" alt="" />
                      Me
                    </div>
                    <span>{{ customFormatterV1(val.created_at) }}</span>
                  </div>
                  <p v-html="val.note ? val.note : ''"></p>
                  <div v-if="!_.isEmpty(val.note_attachment)" class="attachment-list mt-2">

                    <div class="img-thumbnail" v-for="(a, i) in val.note_attachment">
                      <img class="rounded" v-bind:src="a" style="max-width: 100%" height="64"
                        @click.prevent="openImageInBrowser" />
                    </div>
                  </div>
                </div>
                <!-- <div class="ticket-reply-box">
                  <div class="ticket-reply-box-head">
                    <div>
                      <img
                        class="img-circle"
                        src="../../../public/assets/images/logo-mini.svg"
                        alt=""
                      />
                      Rocket Fibre
                    </div>
                    <span>28 Feb 2022</span>
                  </div>
                  <p>
                    Lorem ipsum dolor sit amet consectetur. Morbi sed cras fames
                    at. Penatibus luctus dolor enim pharetra ac amet. At commodo
                    morbi egestas aenean vestibulum mauris aliquet. Et vitae
                    proin gravida dui aenean pretium faucibus. Orci quam id
                    consequat odio.
                  </p>
                </div> -->

                <form action="javascript:void(0)" @submit.prevent="createTicketNote" method="POST" novalidate>
                  <div class="form-group">
                    <label for="">Reply ticket</label>
                    <textarea class="form-control" rows="3" placeholder="Write your message"
                      v-model="ticketNote.note"></textarea>


                  </div>


                  <div class="form-group">
                    <label for="attachment">Attachments</label>
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th class="text-center" scope="col">SL.</th>
                          <th class="text-center" scope="col">File Name</th>
                          <th class="text-center" scope="col">Action</th>
                        </tr>
                      </thead>
                      <tbody class="t-body">
                        <tr class="text-center" v-for="(item, index) in ticketNote.attachments">
                          <td class="text-center">{{ index + 1 }}</td>
                          <td class="text-center">{{ item.name }}</td>
                          <td class="text-center">
                            <button type="button" class="btn btn-primary" @click.prevent="removeFileItem(item.id)">
                              <i class="fa fa-trash" aria-hidden="true"></i>
                            </button>
                          </td>
                        </tr>
                        <tr v-if="ticketNote.attachments.length == 0">
                          <td class="text-center" colspan="100%"> No attachment found yet.</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="form-group">


                    <div class="input-group">
                      <div class="custom-file">
                        <input accept=".png, .jpg, .jpeg" type="file" name="attachment" class="custom-file-input"
                          id="attachment" @change="selectFile" />
                        <label class="custom-file-label" for="attachment">Choose file </label>
                      </div>
                    </div>

                  </div>

                  <button type="submit" class="btn btn-dark-blue">Reply</button>
                </form>
              </div>
            </section>
          </div>
          <div class="col-md-4">
            <div class="card ticket-intro">
              <div class="card-header">
                <h3 class="card-title">Open new ticket</h3>
              </div>
              <div class="card-body">
                <p>
                  This private ticketing system is developed to handle queries
                  &amp; complain of our direct customers.
                </p>
                <div class="d-flex justify-content-between">
                  <router-link :to="{ name: 'open-ticket' }" class="btn btn-dark-blue">
                    Open New Ticket
                  </router-link>
                  <a class="btn btn-help" href="javascript:void(0);"
                  @click.prevent="goToHelp">Get help</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<style scoped>
.closed,
.pending,
.open,
.in-progress {
  border-radius: 100px;
  text-align: center;
  margin-left: auto;
  display: inline-block;
  font-size: 13px;
}

.status.closed {
  color: #16a085;
  background-color: #e1f9f4;
  border-color: #e1f9f4;
}

.status.pending {
  color: #f1711d;
  background-color: #ffe9dd;
  border-color: #ffe9dd;
}

.status.open {
  color: #2980b9;
  background-color: #e4f4ff;
  border-color: #e4f4ff;
}

.status.in-progress {
  color: #efb548;
  background-color: #fbeacb;
  border-color: #fbeacb;
}

img.attachment:hover {
  cursor: pointer;
}

.note-attachment {
  padding-top: 0.75em;
}
</style>
<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import { mapGetters } from "vuex";

export default {
  name: "TicketDetails",
  metaInfo: {
    title: "Ticket Details",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
  },

  data: () => ({
    pid: null,
    ticketData: {},
    ticketNote: {
      note: "",
      attachments: []
    },
    order_by: "asc",
    api_url: "",
    showFilter: false,
    filter: {},
    dateRange: "",
    pre: [],
    is_loading: false,
    has_permission: true,
    max_file_size: 5 * 1024 * 1024, // max allowed file size in byte, 5MB
    companyName: process.env.VUE_APP_COMPANY_NAME || '',
  }),

  computed: {
    ...mapGetters(["profile"]),
  },
  // method is called after page load
  mounted: function () {
    // this.$route.query
    this.pid = this.$route.params.id;
    console.log("Ticket ID::", this.pid);
    if (this.isMobile()) {
      var openOrClose = window.$(document).find(".sidebar-mini");
      if ($(openOrClose).hasClass("sidebar-open")) {
        window.$(document).find(".push-menu-class").trigger("click");
      }
      // window.$(document).find('.push-menu-class').trigger('click');
    }

    this.companyName = process.env.VUE_APP_COMPANY_NAME || '';
    this.loadTicketDetails();
  },

  metaInfo() {
    return {
      title: this.companyName
        ? `Ticket Details | ${this.companyName}`
        : "Ticket Details",
    };
  },

  methods: {

    goToHelp: function () {
      let selfCareHelpLink = process.env.VUE_APP_HELP_BASE_URL || '#';
      selfCareHelpLink = this.cleanWebLink(selfCareHelpLink);
      window.open(selfCareHelpLink, "_blank", "noopener,noreferrer");
    },

    cleanWebLink(link) {
      console.log("Input Link", link);
      link = link.replace(/^['"]+|['";]+$/g, '');
      console.log("Modified Link", link);
      return link;
    },

    removeFileItem: function (id) {
      //this.ticket.files
      console.log("Id::", id);
      console.log("Current List:::", this.ticketNote.attachments);
      this.ticketNote.attachments = this.ticketNote.attachments.filter(x => x.id !== id);
    },

    selectFile: function (event) {
      // `files` is always an array because the file input may be in multiple mode
      const file = event.target.files[0];
      console.log("File object::", file);
      const uploadFileSize = file.size // file size in byte
      // accept only .png, .jpg, .jpeg
      console.log(file.type);
      const allowedExtensionRegex = (/(jpg|jpeg|png)$/i);

      if (!allowedExtensionRegex.test(file.type)
      ) {
        this.$toaster.error("Please Select an image file with extension [ png, jpg, jpeg ]");
        return false;
      }
      if (uploadFileSize > this.max_file_size) {
        this.$toaster.error("Please Select a file smaller than 5MB");
        return false;
      }

      if (this.ticketNote.attachments.length >= 5) {
        this.$toaster.error("Sorry!, number of attachment exceeded.");
        return false;
      }

      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // this.value.avatar = reader.result;
        // this.temp_avatar = reader.result;
        console.log("Reader Result::", reader.result);
        const uniqueId = new Date().getTime(); // miliseconds since 1st Jan 1970
        this.ticketNote.attachments.push({ id: uniqueId, name: file.name, size: file.size, data: reader.result });
      };
    },

    openImageInBrowser(event) {
      console.log("Event:::", event);
      const imgSrc = event.target.src;
      console.log("imgSrc:::", imgSrc);
      window.open(imgSrc, "_blank").focus();
    },

    htmlToText(html) {
      return html.replace(/</g, "&lt;").replace(/>/g, "&gt;");
    },
    decodeHtml: function (html) {
      var txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    },

    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD hh:mm:ss");
    },
    customFormatterV1(date) {
      return moment(date).format("DD MMM YYYY, HH:mm:ss");
    },

    createTicketNote: function () {
      const _this = this;
      if (
        _this.ticketNote.note === null ||
        _this.ticketNote.note.trim() === ""
      ) {
        _this.$toaster.error("Please, type some note!");
        return;
      }
      axios({
        method: "POST",
        url: `/createTicketNote/${_this.pid}`,
        data: _this.ticketNote,
        headers: { "Content-Type": "application/json" },
      })
        .then(function (response) {
          console.log(response.data);
          const responseData = response.data;
          _this.is_loading = false;
          _this.$toaster.success(response.data.message);
          Object.keys(_this.ticketNote).forEach((key) => {
            _this.ticketNote[key] = null;
          });
          _this.$router.go(0);
        })
        .catch((errors) => {
          _this.is_loading = false;
          // _this.$setErrorsFromResponse(errors.response.data);
        })
        .finally(() => {
          _this.is_loading = false;
        });
    },

    loadTicketDetails: function () {
      const _this = this;
      if (_this.pid) {
        _this.is_loading = true;
        axios
          .get(
            `/ticketDetails/${_this.pid}`
            // {params:{}}
          )
          .then((response) => {
            const stateName = response.data.ticket_state
              ? response.data.ticket_state.states
              : "";

            const state_names = stateName.split(/[ ,]+/);
            const className =
              state_names.length > 0 ? state_names.join("-").toLowerCase() : "";

            response.data.statusClass = className;
            _this.ticketData = response.data;
            _this.is_loading = false;
          })
          .catch((error) => {
            _this.is_loading = false;
          })
          .finally(() => {
            _this.is_loading = false;
          });
      }
    },
  },
};
</script>
<style scoped>
.attachment-list {
  display: flex;
  flex-wrap: wrap;
  grid-gap: 10px;
}

.attachment-list img {
  object-fit: cover;
  cursor: pointer;
}
</style>
